<template>
	<div class="item-param-key-value">
		<MultipleSelectSettingsEditor
			v-bind="$attrs"
			@onChange="onChange"
			:isOptionValue="true"
			:addOptionText="addOptionText"
			:keyPlaceholder="keyPlaceholder"
			:valuePlaceholder="valuePlaceholder"
			:options="options"
			:readonly="readonly"
			allowMultipleValue
			:allowTableAndItemValue="allowTableAndItemValue"
		/>
	</div>
</template>

<script>
import cloneDeep from 'lodash/cloneDeep';
import MultipleSelectSettingsEditor from '@/components/BlockEditorWidget/FieldSettings/FieldOptions/MultipleSelectSettingsEditor/MultipleSelectSettingsEditor';

const defaultValue = [{ text: '', value: '', id: 1 }];
export default {
	name: 'ItemKeyValuePropertyInput',
	components: { MultipleSelectSettingsEditor },
	props: {
		param: { type: Object },
		node: { type: Object },
		readonly: { type: Boolean },
	},
	methods: {
		onChange(result) {
			this.localValue = result;
			this.$emit('update-input-field', result);
		},
	},
	computed: {
		options() {
			return Array.isArray(this.localValue) ? this.localValue : defaultValue;
		},
		keyPlaceholder() {
			return this.param.key_place_holder;
		},
		allowTableAndItemValue() {
			return this.param.allow_tables;
		},
		valuePlaceholder() {
			return this.param.val_place_holder;
		},
		addOptionText() {
			return this.param.add_option_text || 'Add item';
		},
	},
	data() {
		return {
			localValue: cloneDeep(this.node.params_map?.[this.param.key] || []),
			localIsDropdownOpen: true,
		};
	},
};
</script>
<style lang="scss" scoped>
.item-param-key-value {
	border: 1px solid var(--seconday-border-color);
	border-radius: 5px;
	padding: 10px;
	margin-top: 10px;
	padding-top: 20px;
	::v-deep {
		.add-option-container {
			padding-left: 20px;
		}
	}
}
</style>
